const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

/**
 * Converts the provided date to a human readable format -> August 29, 2019
 * @param {Date} date
 */
export function toHumanReadable(date) {
  if (!(date instanceof Date)) return;
  if(isNaN(date.getTime()))
  return ;
  return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
}
